import React from "react";
import TrafficItem from "./TrafficItem";

const TrafficList = ({ data }) => {
  return (
    <div className="trafficList">
      {data.length > 0 ? (
        data.map((item, index) => <TrafficItem key={item.id || `traffic-item-${index}`} item={item} />)
      ) : (
        <p style={{ color: "#113C33" }}>Derzeit liegen uns keine Verkehrsmeldungen vor. Radio Erzheimat wünscht gute Fahrt!</p>
      )}
    </div>
  );
};

export default TrafficList;
